import { cn } from '@shared/utils';
import type { GetAllCardsResponse } from '@shared/api';
import { TableStatements } from './tableStatements';
import styles from '../cards.module.css';

interface StatementsProps {
  className?: string;
  card: GetAllCardsResponse;
}

export const Statements = (props: StatementsProps) => {
  return (
    <div>
      <h2
        className={cn(
          'mt-27.75 w-full text-center font-[Prata] text-[56px] text-[#272727]',
          'max-md:relative max-md:m-0 max-md:pt-32.5 max-md:text-[28px] max-md:before:absolute max-md:before:top-6.75 max-md:before:left-[50%] max-md:before:-ml-11.5 max-md:before:h-[92px] max-md:before:w-[92px] max-md:before:bg-no-repeat',
          styles['cards-header-statements'],
          props.className,
        )}
      >
        Statements
      </h2>
      <TableStatements card={props.card} />
    </div>
  );
};
